import React from "react";
import Link from "next/link";
import { BOTS } from "@lango/api/src/queries/config/constants";
import { useBots } from "@/api/config/useBots";

import styles from "./Home.module.css";

export const Home: React.FC = () => {
  useBots();
  return (
    <>
      <main className={styles.main}>
        <div className={styles.previewText}>version préliminaire</div>
        <h1 className={styles.title}>Pratique avec l’IA !</h1>
        <p className={styles.subtitle}>
          Tu peux choisir le sujet qui t’inspire le plus parmi les 3 sujets ci-
          dessous ! Tu peux lui poser 7 questions en tout.
        </p>
        <div className={styles.bots}>
          {BOTS?.map((bot) => (
            <Link className={styles.link} href={`/chat/${bot.id}`} key={bot.id}>
              <img
                src={bot ? `/botsProfiles/${bot.avatar}.png` : undefined}
                alt={""}
                className={styles.avatar}
              />
              <div>
                <div className={styles.name}>{bot.name}</div>
                <div className={styles.description}>{bot.subtitle}</div>
              </div>
            </Link>
          ))}
        </div>
      </main>
      <div className={styles.powered}>
        Propulsé par{" "}
        <a href={"https://langotalk.io"} target="_blank">
          <img alt="Langotalk logo" className={styles.logo} src={"/logo.svg"} />
        </a>
      </div>
    </>
  );
};
